import { ControlBarButton, ControlBarButtonProps, ControlBarButtonStrings, ControlBarButtonStyles } from "@azure/communication-react";
import React from "react";
import { EyeFilled, EyeOffFilled } from "@fluentui/react-icons";


interface ControlBarActiveElementButtonProps extends ControlBarButtonProps{
    onClick: () => void;
    checked: boolean;
    styles?: ControlBarButtonStyles;
}

export const ControlBarActiveElementButton = (props: ControlBarActiveElementButtonProps) => {

    const CustomIconShow = () => <EyeFilled fontSize={24} />;
    const CustomIconHide = () => <EyeOffFilled fontSize={24} />;

    const strings: ControlBarButtonStrings = {
        tooltipOnContent: "Inhalt verstecken",
        tooltipOffContent: "Inhalt anzeigen",
    }

    return (
        <ControlBarButton
            {...props}
            strings={strings}
            onRenderOnIcon={CustomIconShow}
            onRenderOffIcon={CustomIconHide}
            onClick={() => props.onClick()}
        />
    );
}
